export function getPageOffsets(el) {
  function dw_getScrollOffsets() {
    const doc = document
    const w = window
    let x, y, docEl

    if (typeof w.scrollX === "number") {
      x = w.scrollX
      y = w.scrollY
    } else {
      docEl =
        doc.compatMode && doc.compatMode === "CSS1Compat"
          ? doc.documentElement
          : doc.body
      x = docEl.scrollLeft
      y = docEl.scrollTop
    }
    return { x: x, y: y }
  }

  const sOff = dw_getScrollOffsets()
  let left = 0
  let right = 0
  let top = 0
  let bottom = 0

  const props = el.getBoundingClientRect()

  left = props.left + sOff.x
  right = props.right + sOff.x
  top = props.top + sOff.y
  bottom = props.bottom + sOff.y

  return {
    left: Math.round(left),
    right: Math.round(right),
    top: Math.round(top),
    bottom: Math.round(bottom),
    height: el.offsetHeight,
    width: el.offsetWidth,
    scrollY: sOff.y,
    scrollX: sOff.x,
  }
}

export function scrollYWithOffset(elementId, offset) {
  document.getElementById(elementId).scrollIntoView()
  const scrolledY = window.scrollY

  if (scrolledY) {
    window.scroll(0, scrolledY - offset)
  }
}

export function getQueryStringParams(query) {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
          const [key, value] = param.split("=")
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, " "))
            : ""
          return params
        }, {})
    : {}
}

export function getWindowWidth() {
  return document.documentElement.clientWidth
}

export function tempDisableScrollY(timeMS) {
  if (document.body.clientHeight > window.innerHeight) return

  const { overflowY } = document.body.style

  document.body.style.overflowY = "hidden"

  setTimeout(() => {
    document.body.style.overflowY = overflowY
  }, timeMS)
}

export function getTextWidth(text, font) {
  const canvas =
    getTextWidth.canvas ||
    (getTextWidth.canvas = document.createElement("canvas"))

  const context = canvas.getContext("2d")
  context.font = font

  const metrics = context.measureText(text)
  return metrics.width
}
